import { PageState } from 'models/PageState';

export const getFaqs = (state: PageState) => {
  return state.currentPage.frequentlyAskedQuestions;
};
